import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1748.31786,252.722184 C1519.30156,23.7058912 1146.78975,23.8126587 917.88022,252.722184 L125.131513,1045.47089 C44.5220486,1126.18712 0,1233.3817 0,1347.40939 C0,1461.54385 44.5220486,1568.73842 125.131513,1649.34789 C286.563977,1810.78035 567.789579,1810.78035 729.115276,1649.34789 L1446.48613,932.083804 C1550.37091,828.092256 1550.37091,658.865764 1446.27259,554.553914 C1342.17428,450.562367 1172.62748,450.669134 1068.84947,554.660682 L464.865707,1158.64444 L615.941723,1309.61369 L1219.71195,705.736698 C1240.63838,685.023803 1274.59045,684.810268 1295.30334,705.523163 C1316.12301,726.449594 1316.12301,760.401659 1295.41011,781.221322 L578.146027,1498.37864 C497.429795,1579.09487 356.816994,1579.09487 276.100762,1498.37864 C235.742646,1458.02052 213.535005,1404.42324 213.535005,1347.40939 C213.535005,1290.39554 235.742646,1236.79826 276.100762,1196.44014 L1068.84947,403.691433 C1214.48034,258.274095 1451.5042,258.06056 1597.34861,403.691433 C1742.97948,549.322307 1742.97948,786.559698 1597.34861,932.190571 L842.395596,1687.25035 L993.364845,1838.2196 L1748.31786,1083.15982 C1977.22738,854.250294 1977.22738,481.738478 1748.31786,252.722184",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconPaperclipSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconPaperclipSolid, _Component);

  var _super = _createSuper(IconPaperclipSolid);

  function IconPaperclipSolid() {
    _classCallCheck(this, IconPaperclipSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconPaperclipSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconPaperclip",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconPaperclipSolid.displayName = "IconPaperclipSolid";
  return IconPaperclipSolid;
}(Component);

IconPaperclipSolid.glyphName = 'paperclip';
IconPaperclipSolid.variant = 'Solid';
IconPaperclipSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconPaperclipSolid;
export { IconPaperclipSolid };